import { UpdateSurveyInput } from '@/types/schema';

import { SurveyEditorDetailsFragment } from '../../../../graphql/fragments/generated/SurveyEditorDetails';

export enum SurveySettingsDialogTypes {
  Tags = 'Tags',
  WorkspaceSettings = 'WorkspaceSettings',
  AssignmentRestriction = 'AssignmentRestriction',
}

export interface DialogState {
  Component: DialogComponent;
}

export interface SurveySettingsDialogProps {
  onSubmit: (props: Partial<UpdateSurveyInput>) => void;
  onClose: () => void;
  initialSurvey: SurveyEditorDetailsFragment;
}

export type DialogComponent = React.ComponentType<SurveySettingsDialogProps>;
